<template>
  <Tab @close="removeCurrent">
    <template #toolbar-items>
      <!-- ------------------------ wall ------------------------ -->
      <TabToolbarButton
          v-model="page"
          :menu="menu"
          :selected="page === 'wall'"
          icon="fa-list"
          name="wall"
      ></TabToolbarButton>
      <!-- ------------------------ top ------------------------ -->
      <TabToolbarButton
          v-model="page"
          :menu="menu"
          :selected="page === 'top'"
          icon="fa-list"
          name="top"
      ></TabToolbarButton>
      <!-- ------------------------ user ------------------------ -->
      <TabToolbarButton
          v-if="selectedUser.hasOwnProperty('id')"
          v-model="page"
          :menu="menu"
          :selected="page === 'user'"
          icon="fa-user"
          name="user"
      ></TabToolbarButton>
    </template>
    <template #container>
      <!-- ------------------------ url ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="me/feed/page" name="wall">
        <template #content>
          <v-btn style="position: absolute;right: 20px; top: 10px;" :title="$t('dashboard.feed.refresh')" icon @click="fetchFeed">
            <v-icon x-small>
              fa-sync-alt
            </v-icon>
          </v-btn>
          <v-card
              v-for="publication in feed"
              :key="publication.id + publication.database"
              class="my-4"
              flat
              @click="openUrl(publication.url)"
          >
            <v-card-text>
              <v-row>
                <v-col class="tw-flex tw-items-center tw-justify-between">
                  <span>
                    <v-avatar v-if="publication.user.avatar" size="48">
                      <img :alt="publication.user.user_name" :src="publication.user.avatar"/>
                    </v-avatar>
                    <span
                        v-if="getName(publication).length > 0"
                        :title="getUserName(publication)"
                        class="blue--text"
                        v-html="publication.solicitation_id > 0 ? getName(publication) : getName(publication)"
                    ></span>
                    <span v-else class="blue--text">@{{ getUserName(publication) }}</span>
                  </span>
                  <span>
                    <v-icon x-small>fa-globe</v-icon>
                    {{ publication.host }}
                  </span>
                  <span>
                    <span class="ml-2">
                      <v-icon color="secondary" style="margin-bottom: 3px;" x-small>fa-star</v-icon>
                      {{ publication.rating }}/5
                    </span>
                    <span v-if="publication.like && publication.like.counter > 0" class="ml-2" x-small>
                      <v-icon class="pb-1" x-small>fa-thumbs-up</v-icon>
                      {{ publication.like.counter }}
                    </span>
                    <span class="ml-2">{{ formatPublicationDate(publication) }}</span>
                  </span>
                </v-col>
              </v-row>

              <v-row class="container">
                {{ publication.message }}
              </v-row>
            </v-card-text>
          </v-card>
        </template>
      </TabPage>
      <!-- ------------------------ top ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="me/ranking/page" name="top">
        <template #content>
          <v-container>
            <RankingList @show="show"/>
          </v-container>
        </template>
      </TabPage>
      <!-- ------------------------ user ------------------------ -->
      <TabPage :menu="menu" :page="page" name="user" no-documentation>
        <template #content>
          <v-container>
            <RankingListSelected v-if="selectedUser.id > 0" :user="selectedUser"/>
          </v-container>
        </template>
      </TabPage>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"
import {Types} from "@/store/modules/publications"
import {assign, chain, spread} from "lodash"
import {Types as TypesLoading} from "@/store/modules/loading"
import Tab from "@/components/common/template/tabs/Tab";
import RankingList from "@/components/me/tabs/Feed/RankingList";
import RankingListSelected from "@/components/me/tabs/Feed/RankingListSelected";


export default {
  name: "Feed",
  mixins: [tab],
  components: {
    Tab,
    RankingList,
    RankingListSelected,
  },
  data: () => ({
    selectedUser: {},
    feedIncrement: 5,
    pages: ["wall", "top"],
    page: "wall",
    menu: "feed",
  }),
  watch: {
    page: function (val) {
      if (val === "top") {
        this.selectedUser = {}
      }
    },
  },
  mounted() {
    this.fetchFeed()
  },
  computed: {
    feed() {
      return this.$store.state.publications.feed
    },
  },
  methods: {
    fetchFeed() {
      this.$store.commit(TypesLoading.mutations.LOADING_YES)
      this.$axios
          .get("office/me/users/feed")
          .then(response =>
              this.$store.dispatch(
                  Types.actions.FEED,
                  // Get the last 5 publications and concat/merge with all publications available in the storage.
                  // If the localstorage is cleared, the feed going to be lost and a new will be created and populated
                  chain([...Object.values(response.data)])
                      .concat(this.$store.state.publications.feed)
                      .groupBy("id")
                      .flatMap(spread(assign))
                      .reverse()
                      .value()
              )
          )
          .finally(() => this.$store.commit(TypesLoading.mutations.LOADING_NO))
    },
    formatPublicationDate(publication) {
      let dt = new Date(publication.created_at)
      return dt.toLocaleDateString("fr-fr")
    },
    slicedUrl(url) {
      const limit = 100
      const sliced = url.slice(0, limit)
      return limit <= url.length ? sliced + "..." : url
    },
    openUrl(url) {
      window.open(url, "_blank")
    },
    getUserName(publication) {
      const {user_name} = publication.user
      const semicolonPos = user_name.indexOf(":")
      if (semicolonPos > 0) {
        return ""
      } else {
        return `${user_name}`
      }
    },
    getName(publication) {
      const {first_name} = publication.user
      const {last_name} = publication.user
      let name = ""
      if (first_name) name = name + " " + first_name
      if (last_name) name = name + " " + last_name
      return name.trim()
    },
    displayOrigin(publication) {
      return this.$t("origin.source") + this.getOrigin(publication)
    },
    getOrigin(publication) {
      const securating = "Securating"
      const {user_name} = publication.user
      const semicolonPos = user_name.indexOf(":")
      if (semicolonPos > 0) {
        const prefix = user_name.substr(0, semicolonPos)

        switch (prefix) {
          case "anonymous":
            return securating
          default:
            return `${this.$t("origin." + prefix)}`
        }
      } else {
        return securating
      }
    },
    show(user) {
      this.selectedUser = user
      this.page = "user"
    },
  },
}
</script>
